
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

interface SubscribeButtonProps {
  className?: string;
}

const SubscribeButton = ({ className }: SubscribeButtonProps) => {
  const navigate = useNavigate();

  const handleSubscribe = () => {
    // Navigate to the settings page with the subscription section active
    navigate('/dashboard/settings', { state: { activeMenu: 'subscription' } });
  };

  return (
    <Button 
      variant="default" 
      size="sm" 
      className={`social-profiles-button font-sans ${className || ''}`}
      onClick={handleSubscribe}
    >
      Souscrire
    </Button>
  );
};

export default SubscribeButton;
